export default "__VITE_ASSET__BsC0Ult6__"